import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import { setFlow } from "redux/slices/user";
import Session from "redux/classes/Session";

/**
 * Fetch the model's Flow diagram. The flow is stored as Mermaid source at
 * `s3://<bucket>/<alias>/Flow.mmd`. We hit objectLoader for a presigned URL,
 * fetch the file, and store the raw Mermaid text in `state.user.flow`. The
 * Flow page renders it through MarkdownViewer (which already supports
 * mermaid via MermaidBlock).
 *
 * Older flows that were served as Flow.jpeg are NOT supported by this path —
 * they should be replaced with Flow.mmd at the model root and re-uploaded.
 */
export function LoadFlowAction(session: Session, modelAlias: string) {
    return async (dispatch: AppDispatch) => {
        dispatch(setFlow({ flow: "" }));

        const payload = JSON.stringify({
            "model": modelAlias,
            "path": "Flow.mmd"
        });

        let response: {status: number, data: any} = await dispatch(CallLambda(session, "objectLoader", payload))

        if (response.status !== 200 || !response.data?.url) {
            return;
        }

        // objectLoader returns the presigned URL base64-encoded.
        let presignedUrl: string;
        try {
            presignedUrl = atob(response.data.url);
        } catch {
            return;
        }

        try {
            const fileResp = await fetch(presignedUrl);
            if (!fileResp.ok) return;
            const mermaidSource = await fileResp.text();
            dispatch(setFlow({ flow: mermaidSource }));
        } catch {
            // Network or parse error — leave flow empty so the page shows nothing.
        }
    }
}